import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';

import { NewgroupIcon } from '../../../../../common/icons';

import AirModal from '../../../../../common/components/AirModal';
import AirButton from '../../../../../common/components/AirButton';
import AirInput from '../../../../../common/components/AirInput';

import './NewGroupModal.css';

@inject('translationsStore', 'groupsStore', 'commonStore')
@observer
export default class NewGroupModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
      groupname: '',
      groupdescription: '',
      groupphonenumber: ''
    };
  }

  show = () => {
    this.setState({ visible: true });
  };

  close = () => {
    this.setState({ visible: false });
  };

  createGroup = () => {
    const { groupname, groupdescription, groupphonenumber } = this.state;
    const { commonStore, groupsStore } = this.props;
    //dovrei chiamare le api per la creazione gruppo e ricaricare il gruppo...
    if (!!groupname) {
      this.close();
      commonStore.setLoadingMessage('sto creando il gruppo');
      commonStore.setLoading(true);
      groupsStore.create(groupname, groupdescription, groupphonenumber).then(() => {
        commonStore.setLoading(false);
      });
    } else {
      console.log('error');
    }
  };

  setGroupname = e => {
    this.setState({ groupname: e.target.value });
  };

  setGroupdescription = e => {
    this.setState({ groupdescription: e.target.value });
  };

  setGroupphonenumber = e => {
    this.setState({ groupphonenumber: e.target.value });
  };

  render() {
    const { translationsStore } = this.props;
    return (
      <AirModal
        className="NewGroupModal"
        visible={this.state.visible}
        icon={<NewgroupIcon style={{ width: '62px', height: '45px' }} />}
        onCancel={this.close}
        okButton={<AirButton size="large" light label={translationsStore.translate('newgroup.create')} />}
        onOk={this.createGroup}
        title={translationsStore.translate('newgroup.modaltitle')}
        subtitle={translationsStore.translate('newgroup.modalsubtitle')}
      >
        <div>
          <AirInput label={translationsStore.translate('newgroup.name')} value={this.state.groupname} onChange={this.setGroupname} maxlength="20" />
          <AirInput
            label={translationsStore.translate('newgroup.description')}
            textarea
            value={this.state.groupdescription}
            onChange={this.setGroupdescription}
            maxlength="100"
            autosize={{ minRows: 2, maxRows: 2 }}
          />
          <AirInput
            label={translationsStore.translate('newgroup.phoneNumber')}
            value={this.state.groupphonenumber}
            onChange={this.setGroupphonenumber}
            maxlength="20"
          />
        </div>
      </AirModal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/GroupsManagerDashboard/SubHeader/NewGroupModal/NewGroupModal.js